import {
  matchType
} from "./chunk-ARWLRO3D.mjs";

// lib/components/search-status-icon/search-status-icon/search-status-icon.tsx
import classNames from "classnames";
import { jsx } from "@emotion/react/jsx-runtime";
var SearchStatusIcon = ({
  status,
  small
}) => {
  return /* @__PURE__ */ jsx("span", { className: classNames("icon", small && "is-small"), children: matchType(status, {
    idle: /* @__PURE__ */ jsx("i", { className: "fas fa-magnifying-glass" }),
    debouncing: /* @__PURE__ */ jsx("i", { className: "fas fa-pen" }),
    searching: /* @__PURE__ */ jsx("i", { className: "fas fa-spinner fa-pulse" })
  }) });
};

export {
  SearchStatusIcon
};
